import client from './client';

const endpoint = '/v1/Broker';

const preload = (page, docPerPage) => client.get(`${endpoint}/Preload?Page=${page}&PostsPerPage=${docPerPage}`);

const brokers = (page, docPerPage) => client.get(`${endpoint}?Page=${page}&PostsPerPage=${docPerPage}`);

const createBroker = schema => client.post(`${endpoint}`, schema);

const findByName = (name, page, docPerPage) => client.get(`${endpoint}/FindByName?filter=${name}&Page=${page}&PostsPerPage=${docPerPage}`);

const getByColumn = (col, val, page, docsPerPage) => (
  client.get(`${endpoint}/getbycoulum?col=${col}&value=${val}&Page=${page}&PostsPerPage=${docsPerPage}`)
);

const deleteBroker = id => client.delete(`${endpoint}/${id}`);

const updateBroker = (id, schema) => client.put(`${endpoint}/${id}`, schema);

export default {
  preload,
  brokers,
  createBroker,
  findByName,
  getByColumn,
  deleteBroker,
  updateBroker
}